import { useState } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);
  const whatsappUrl = 'https://wa.me/905309042429?text=Merhaba,%20danışmanlık%20hakkında%20bilgi%20almak%20istiyorum.';

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="nofollow noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 cursor-pointer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="WhatsApp ile iletişim"
    >
      {/* Label */}
      <div
        className={`bg-white text-warm-dark text-xs font-medium px-3 py-2 rounded-full shadow-md border border-cream-deeper transition-all duration-300 whitespace-nowrap ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        Hızlı bilgi al
      </div>

      {/* Button */}
      <div className="w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full shadow-lg hover:scale-110 transition-transform duration-300">
        <i className="ri-whatsapp-line text-white text-2xl" />
      </div>
    </a>
  );
}